import throttle from 'lodash-es/throttle';

export default class Accordion {
  constructor(el, trigger, body, bodyInternal, onChange) {
    if (el === null && trigger === null && body === null) {
      return;
    }

    this.el = el;
    this.trigger = trigger ? el.querySelector(trigger) : null;
    this.contentBody = el.querySelector(body);
    this.contentBodyInternal = el.querySelector(bodyInternal);
    this.openClass = 'is-open';
    this.state = {
      isOpen: false,
      openHeight: null,
      closeHeight: 0,
    };

    if (this.trigger.classList.contains(this.openClass)) {
      this.state.isOpen = true;
    }

    const nullAction = () => {}; // eslint-disable-line
    this.onChange = onChange || nullAction;

    if (this.trigger !== null && this.contentBody !== null && this.contentBodyInternal !== null) {
      this.init();
    }
  }

  addEvents() {
    this.setOpenHeight();
    if (this.trigger) {
      this.trigger.addEventListener('click', this.toggleHeight.bind(this));
    }

    window.addEventListener('resize', throttle(this.resizeHeight.bind(this), 400));
  }

  resizeHeight() {
    this.setOpenHeight();
    if (this.state.isOpen) {
      this.contentBody.style.height = `${this.state.openHeight}px`;
    }
  }

  setOpenHeight() {
    this.state.openHeight = this.contentBodyInternal.scrollHeight;
  }

  open() {
    this.state.isOpen = true;
    if (this.trigger) {
      this.trigger.classList.add(this.openClass);
    }

    if (this.contentBody) {
      this.contentBody.classList.add(this.openClass);
      this.contentBody.style.height = `${this.state.openHeight}px`;
    }
  }

  close() {
    this.state.isOpen = false;
    if (this.trigger) {
      this.trigger.classList.remove(this.openClass);
    }
    if (this.contentBody) {
      this.contentBody.classList.remove(this.openClass);
      this.contentBody.style.height = '0px';
    }
  }

  toggleHeight(el) {
    el.preventDefault();
    if (this.state.isOpen) this.close(); // eslint-disable-line curly
    else this.open(); // eslint-disable-line curly
    this.onChange(this.state.isOpen);
  }

  init() {
    this.addEvents();
  }
}
